angular.module('cimerFrontEndApp').directive('compositeScoreDisplay', ['SurveyService', '$uibModal', function (SurveyService, $uibModal) {
	'use strict';
	return {
		restrict: 'EA',
		templateUrl: '/Content/Templates/survey/compositeScoreDisplayTemplate.html',
        scope: {
			compositeScore: '=compositeScore',
			index: '=index',
			form: '=form',
			formSubmitted: '=formSubmitted',
            removeCompositeScore: '&',
            canEdit: '=canEdit'
		},
        link: function (scope, elements, attrs) {
            scope.compositeScoreNameMaxLength = 255;
            // Preview a question in a modal
            scope.previewSingleSelectQuestion = function (questionIndex, allQuestionsOpen) {
                var question;
                if (allQuestionsOpen) {
                    question = angular.copy(scope.compositeScore.allQuestions[questionIndex]);
                }
                else {
                    question = angular.copy(scope.compositeScore.selectedQuestions[questionIndex]);
                }
				// Temporarily reset question numbers
				question.details.questionCount = 1;

				var previewQuestionModalInstance = $uibModal.open({
					animation: true,
					templateUrl: '/Content/Templates/survey/previewQuestionModal.html',
					controller: 'PreviewQuestionModalCtrl',
					size: 'lg',
					resolve: {
						question: function () {
							return question;
						}
					}
				});
            }; // end previewSingleSelectQuestion

            scope.toggleEdit = function () {
                if (!scope.canEdit) { return; }
                scope.compositeScore.editMode = !scope.compositeScore.editMode;
            };

            scope.toggleQuestion = function (question, index) {
                if (!scope.canEdit) { return; }
                // update the selected questions list based on new state
                if (question.selected) {
                    if (!scope.compositeScore.hasOwnProperty('selectedQuestions') || scope.compositeScore.selectedQuestions === undefined) {
                        scope.compositeScore.selectedQuestions = [];
                    }
                    scope.compositeScore.selectedQuestions.push(scope.compositeScore.allQuestions[index]);
                }
                else {
                    var deleteQuestionID = scope.compositeScore.allQuestions[index].details.QuestionID;
                    for (var i = 0; i < scope.compositeScore.selectedQuestions.length; i++) {
                        if (scope.compositeScore.selectedQuestions[i].details.QuestionID === deleteQuestionID) {
                            scope.compositeScore.selectedQuestions.splice(i, 1);
                        }
                    }
                }

            }; // end toggleQuestion
		}
	};
}]);